module.exports = __webpack_public_path__ + "static/pawesomeImage-53b6555fe10788a70220c943a8f21557.png";